module.exports = __webpack_public_path__ + "img/up-onlline-clienti.005fd316.png";